export default {
  2: {
    default: {
      portrait: 1,
      landscape: 16 / 9,
    },
    '1:1': {
      portrait: 1,
      landscape: 16 / 9,
    },
    '2:1': {
      portrait: 2,
      landscape: 2,
    },
    '3:4': {
      portrait: 1,
      landscape: 16 / 9,
    },
  },
  3: {
    default: {
      portrait: 3 / 4,
      landscape: 848 / 555,
    },
    '1:1': {
      portrait: 1,
      landscape: 932 / 457,
    },
    '2:1': {
      portrait: 2,
      landscape: 2,
    },
    '3:4': {
      portrait: 3 / 4,
      landscape: 848 / 555,
    },
  },
  4: {
    default: {
      portrait: 3 / 4,
      landscape: 632 / 409,
    },
    '1:1': {
      portrait: 1,
      landscape: 932 / 457,
    },
    '2:1': {
      portrait: 2,
      landscape: 2,
    },
    '3:4': {
      portrait: 3 / 4,
      landscape: 632 / 409,
    },
  },
};
